import {cuppa, log} from "../../../cuppa/cuppa";
import '../../../cuppa/components/cuppa.alert';
import {Globals} from "../../controllers/Globals";

export function Alert({title = "Message", message = "", html = "", accept = "Ok", cancel = "", callback = null, backdropEnabled = false} = {}){

	function onClose(result){
		if(callback){ callback(result) }
		Globals.mainPortal.remove("Alert");
	}

	return (
		<div>
			<cuppa-alert
				title={title}
				message={message}
				accept-text={accept}
				cancel-text={cancel}
				backdrop-enabled={backdropEnabled}
				ref={el=>{ if(el) el.callback = onClose; }}
			>
				{html != "" && (
					<cuppa-alert-content dangerouslySetInnerHTML={{__html:html}}></cuppa-alert-content>
				)}
			</cuppa-alert>
		</div>
	)
}
